module.exports = __webpack_public_path__ + "img/fetchGeneralFail.190d5204.svg";